import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAuthGuard } from './authentication/keycloak/keycloak-guard';
import { LoginComponent } from './authentication/login/login.component';
import { PageRestrictionGuard } from './authorization/page-restriction.guard';
import { AnonymousLayoutComponent } from './layouts/anonymous-layout/anonymous-layout.component';
import { AuthenticatedLayoutComponent } from './layouts/authenticated-layout/authenticated-layout.component';
import { LocationContextGuard } from './location-context/location-context.guard';
import { Pages } from './pages.config';
import { ConMonDeactivateGuard } from './docking/conmon/conmon.guard';

const routes: Routes = [
    {
        path: '',
        component: AuthenticatedLayoutComponent,
        canActivate: [AppAuthGuard],
        canDeactivate: [ConMonDeactivateGuard],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: Pages.locationContext.path,
                loadChildren: () =>
                    import('./location-context/location-context.module').then(mod => mod.LocationContextModule),
                canActivate: [AppAuthGuard],
                data: {
                    onlyShowIfLocationContextIsValid: Pages.locationContext.onlyShowIfLocationContextIsValid
                }
            },
            {
                path: Pages.flights.path,
                loadChildren: () => import('./flights/flights.module').then(mod => mod.FlightsModule),
                canActivate: [AppAuthGuard, PageRestrictionGuard, LocationContextGuard],
                data: {
                    onlyShowIfLocationContextIsValid: Pages.flights.onlyShowIfLocationContextIsValid
                }
            },
            {
                path: Pages.docking.path,
                loadChildren: () => import('./docking/docking.module').then(mod => mod.DockingModule),
                canActivate: [AppAuthGuard, PageRestrictionGuard, LocationContextGuard],
                data: {
                    onlyShowIfLocationContextIsValid: Pages.docking.onlyShowIfLocationContextIsValid
                }
            },
            {
                path: Pages.profile.path,
                loadChildren: () => import('./authentication/profile/profile.module').then(mod => mod.ProfileModule),
                canActivate: [AppAuthGuard, LocationContextGuard],
                data: {
                    onlyShowIfLocationContextIsValid: Pages.profile.onlyShowIfLocationContextIsValid
                }
            },
            {
                path: Pages.maintenance.path,
                loadChildren: () => import('./maintenance/maintenance.module').then(mod => mod.MaintenanceModule),
                canActivate: [AppAuthGuard, PageRestrictionGuard, LocationContextGuard],
                data: {
                    onlyShowIfLocationContextIsValid: Pages.maintenance.onlyShowIfLocationContextIsValid
                }
            },
            {
                path: Pages.statistics.path,
                loadChildren: () => import('./statistics/statistics.module').then(mod => mod.StatisticsModule),
                canActivate: [PageRestrictionGuard, LocationContextGuard]
            },
            {
                path: Pages.errorLogs.path,
                loadChildren: () => import('./error-logs/error-logs.module').then(mod => mod.ErrorLogsModule),
                canActivate: [AppAuthGuard, PageRestrictionGuard, LocationContextGuard],
                data: {
                    onlyShowIfLocationContextIsValid: Pages.errorLogs.onlyShowIfLocationContextIsValid
                }
            },
            {
                path: Pages.eventLogs.path,
                loadChildren: () => import('./event-logs/event-logs.module').then(mod => mod.EventLogsModule),
                canActivate: [AppAuthGuard, PageRestrictionGuard, LocationContextGuard],
                data: {
                    onlyShowIfLocationContextIsValid: Pages.eventLogs.onlyShowIfLocationContextIsValid
                }
            },
            {
                path: '**',
                redirectTo: Pages.docking.path,
                pathMatch: 'full'
            }
        ]
    },
    {
        path: Pages.login.path,
        component: AnonymousLayoutComponent,
        children: [
            {
                path: '',
                component: LoginComponent
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
